export default __webpack_public_path__ + "static/media/fontainebleau4.071a046f.jpg";